import React from "react";

import { DashboardTemplate } from "../../_metronic/_partials/template";

export function DashboardTemplatePage() {
  return <DashboardTemplate />;
}
